const createCustomSelect = () => {
  if (typeof require !== 'undefined') {
    var customSelect = require('custom-select').default;
  }

  const mySelects = customSelect('select');
};

export {createCustomSelect};
